var _excluded = ["sendEvent", "transport"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { setHOCDisplayName } from '@domain-group/fe-helper';
import { AnalyticsProvider } from './analytics-provider';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var withAnalyticsProvider = (eventMapper, boundaryProps) => Component => {
  var HoC = _ref => {
    var sendEvent = _ref.sendEvent,
      transport = _ref.transport,
      props = _objectWithoutProperties(_ref, _excluded);
    return ___EmotionJSX(AnalyticsProvider, _extends({}, boundaryProps, {
      transport: transport,
      sendEvent: sendEvent,
      eventMapper: eventMapper
    }), ___EmotionJSX(Component, props));
  };
  setHOCDisplayName(HoC, Component, 'withAnalyticsProvider');
  return hoistNonReactStatics(HoC, Component);
};